module.exports = __webpack_public_path__ + "static/media/contemplar_te_9.07bb35d0.jpg";